import type { RideRequest } from './MobilityProvider'

export interface UberDeepLinkConfig {
  baseUrl: string
  clientId: string
}

export type UberDeepLinkErrorCode = 'CLIENT_ID_REQUIRED' | 'UNVERIFIED_DESTINATION' | 'INVALID_PICKUP' | 'INVALID_DESTINATION'

export class UberDeepLinkError extends Error {
  constructor(readonly code: UberDeepLinkErrorCode) {
    super(code)
    this.name = 'UberDeepLinkError'
  }
}

function assertCoordinate(latitude: number, longitude: number, code: 'INVALID_PICKUP' | 'INVALID_DESTINATION'): void {
  if (!Number.isFinite(latitude) || latitude < -90 || latitude > 90 || !Number.isFinite(longitude) || longitude < -180 || longitude > 180) {
    throw new UberDeepLinkError(code)
  }
}

export function buildUberDeepLink(config: UberDeepLinkConfig, request: RideRequest): string {
  if (!config.clientId) throw new UberDeepLinkError('CLIENT_ID_REQUIRED')
  if (request.destination.coordinateStatus !== 'PROVIDER_VERIFIED') {
    throw new UberDeepLinkError('UNVERIFIED_DESTINATION')
  }

  assertCoordinate(request.pickup.latitude, request.pickup.longitude, 'INVALID_PICKUP')
  assertCoordinate(request.destination.latitude, request.destination.longitude, 'INVALID_DESTINATION')

  const url = new URL(config.baseUrl)
  const pickup = {
    latitude: request.pickup.latitude,
    longitude: request.pickup.longitude,
    addressLine1: 'Current location',
    addressLine2: 'Browser GPS',
  }
  const dropoff = {
    latitude: request.destination.latitude,
    longitude: request.destination.longitude,
    addressLine1: request.destination.name,
    addressLine2: request.destination.address,
  }

  url.searchParams.set('client_id', config.clientId)
  url.searchParams.set('pickup', JSON.stringify(pickup))
  url.searchParams.set('drop[0]', JSON.stringify(dropoff))
  return url.toString()
}
